import React from 'react';
import ProductionSalesHybrid from './ProductionSalesHybrid';

export default function TargetProductionSalesHybrid() {
  return (
    <ProductionSalesHybrid
      customerName="Target"
      customers={['TARGET']}
      divisions={['10']}
      labels={['TARGET', 'TGT', 'TGTPLUS']}
      defaultExcludeLabels={[]}
      excludedPrograms={[]}
    />
  );
}
